export const formTransactionOptionTypes = Object.freeze({
  sendKudosAsAdmin: "Send kudos to the employee(As an admin)",
  sendKudosBetweenColleagues: "Send kudos to other colleague",
  requestKudos: "Request kudos",
});
